// Rayon — sales territory.
//
// Scope is opt-in twice over: a role has to be marked "Batasi per rayon", AND
// the user has to have a rayon assigned. Either one missing means unrestricted,
// which is what stops this feature blinding everybody the moment it is turned
// on. Events with no rayon stay visible to everyone for the same reason.

import { supabase } from '@/lib/supabase';

export interface Rayon {
  id: string;
  code: string;
  name: string;
  isActive: boolean;
}

export async function listRayons(): Promise<Rayon[]> {
  const { data, error } = await supabase.from('rayons').select('*').order('code');
  if (error) throw new Error(error.message);
  return (data ?? []).map((r) => ({
    id: r.id,
    code: r.code,
    name: r.name,
    isActive: r.is_active,
  }));
}

export async function createRayon(code: string, name: string): Promise<void> {
  const { error } = await supabase.from('rayons').insert({ code, name });
  if (error) throw new Error(error.message);
}

export async function updateRayon(
  id: string,
  patch: { code?: string; name?: string; isActive?: boolean },
): Promise<void> {
  const { error } = await supabase
    .from('rayons')
    .update({
      ...(patch.code !== undefined ? { code: patch.code } : {}),
      ...(patch.name !== undefined ? { name: patch.name } : {}),
      ...(patch.isActive !== undefined ? { is_active: patch.isActive } : {}),
    })
    .eq('id', id);
  if (error) throw new Error(error.message);
}

/** Put a user in a rayon, or clear it (null = sees everything). */
export async function setUserRayon(uid: string, rayonId: string | null): Promise<void> {
  const { error } = await supabase.from('profiles').update({ rayon_id: rayonId }).eq('id', uid);
  if (error) throw new Error(error.message);
}

/** File an event under a rayon, or clear it (null = visible to everyone). */
export async function setEventRayon(eventId: string, rayonId: string | null): Promise<void> {
  const { error } = await supabase.from('events').update({ rayon_id: rayonId }).eq('id', eventId);
  if (error) throw new Error(error.message);
}
